import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { handleNavigate } from "../../../../hooks/handleNavigate";
import { setSectionList, updateSection } from "../../assignmentSlice";

import TypeBox from "./TypeBox";

const TopBar = ({
  currentStep,
  setCurrentStep,
  isPreview = false,
  isReview = false,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { assignment, paragraph, section } = useSelector(
    (state) => state.assignment
  );
  const { mode } = useSelector((state) => state.ui);
  const isMobile = mode === "mobile";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between", // 좌우로 정렬
        alignItems: "center", // 세로 방향 중앙 정렬
        height: isMobile ? "45px" : "70px",
      }}
    >
      {/* 좌측 콘텐츠 */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: isMobile ? "12px" : "14px",
          gap: "1.5vw", // 요소 간 간격
        }}
      >
        <TypeBox type={assignment?.type || "analysis"} isMobile={isMobile} />
        <div>{assignment?.title || ""}</div>
        <div
          style={{
            fontSize: "14px",
            color: "#737373",
          }}
        >
          {assignment?.is_retry && (
            <span style={{ 
              backgroundColor: "#e8f5e8", 
              color: "#2e7d32", 
              padding: "4px 8px", 
              borderRadius: "4px", 
              fontSize: "12px",
              fontWeight: "bold"
            }}>
              복습 {assignment.retry_info?.retry_count || ''}회차
            </span>
          )}
          {paragraph?.title || ""}
        </div>
      </div>

      {/* 우측 버튼 */}
      <button
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "5px",
          border: "1px solid #438CFB",
          color: "#438CFB",
          padding: isMobile ? "5px 12px" : "9.5px 20px",
          cursor: "pointer",
          fontSize: isMobile ? "12px" : "16px",
        }}
        onClick={() => {
          alert("학습 내역이 저장되었습니다.");
          if (currentStep > 1) {
            if (
              currentStep === 3 &&
              !isPreview &&
              !isReview &&
              section.type != "unknown"
            ) {
              const isFinished =
                !["study", "matching"].includes(section.type) &&
                section.answer.length != 0 &&
                !section.answer.some((page) => page.isSubmitted == false);
              dispatch(
                updateSection({
                  sectionId: section.id,
                  data: { answer: section.answer, is_finished: isFinished },
                })
              );
            }
            setCurrentStep(currentStep - 1);
          } else {
            if (isPreview || isReview) {
              window.close();
            } else {
              handleNavigate({ url: "/home", params: {}, navigate });
              dispatch(setSectionList([]));
            }
          }
        }}
      >
        저장하고 나가기
      </button>
    </div>
  );
};

export default TopBar;
